import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'

import { assetUrl } from 'utils/url'

function CardPengKin2025() {
  return (
    <Card className="p-6 !flex-row space-x-4 items-center">
      <img
        src={assetUrl('/illustrations/img-notification-bell.png')}
        alt=""
        width={64}
        height={64}
        className="flex-none"
      />
      <div className="w-full flex-1 space-y-2">
        <Text variant="heading-sm" className="!text-black" as="h2">
          Info Penting: <br />
          Mulai tahun 2025, Pengelolaan Kinerja akan menjadi lebih sederhana dan
          lebih bermakna!
        </Text>
        <ol className="list-disc list-inside">
          <Text as="li">
            Pengembangan Kompetensi tidak lagi berbasis poin. Kini berbasis
            refleksi.
          </Text>
          <Text as="li">
            Bukti Dukung dan Dokumen Akuntabilitas tidak lagi perlu diunggah di
            sistem.
          </Text>
          <Text as="li">
            Periode tidak lagi 2 kali dalam setahun. Kini hanya 1 kali dalam
            setahun.
          </Text>
        </ol>
      </div>

      <Link passHref href="https://guru.kemdikbud.go.id/artikel/1079">
        <Button
          as="a"
          color="black"
          size="md"
          target="_blank"
          aria-label="Selengkapnya"
          type={undefined}
        >
          Selengkapnya
        </Button>
      </Link>
    </Card>
  )
}

export default CardPengKin2025
